/* Floating hero card: cycles through bestsellers.
   Fade-out -> swap content -> fade-in. Pauses on hover/focus and hidden tabs;
   disabled entirely for prefers-reduced-motion. */
(function () {
  'use strict';

  if (window.__dwHeroRotateInit) return;
  window.__dwHeroRotateInit = true;

  function init() {
    var tile = document.querySelector('[data-dw-rotate-tile]');
    var dataEl = document.querySelector('[data-dw-rotate-data]');
    if (!tile || !dataEl) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items || items.length < 2) return;

    var img = tile.querySelector('[data-rt-img]');
    var title = tile.querySelector('[data-rt-title]');
    var price = tile.querySelector('[data-rt-price]');
    var flag = tile.querySelector('[data-rt-flag]');
    if (!img || !title) return;

    var interval = (parseInt(tile.dataset.rtInterval, 10) || 4) * 1000;
    var index = 0;
    var paused = false;

    /* pre-warm the next image so swaps never flash empty */
    function preload(i) {
      var im = new Image();
      im.src = items[i % items.length].img;
    }
    preload(1);

    function swap() {
      if (paused || document.hidden) return;
      index = (index + 1) % items.length;
      var item = items[index];
      tile.classList.add('is-swapping');
      setTimeout(function () {
        img.src = item.img;
        img.removeAttribute('srcset');
        img.alt = item.alt || item.title;
        title.textContent = item.title;
        if (price) price.textContent = item.price;
        if (flag) flag.textContent = item.flag;
        tile.href = item.url;
        tile.classList.remove('is-swapping');
        preload(index + 1);
      }, 310);
    }

    tile.addEventListener('mouseenter', function () { paused = true; });
    tile.addEventListener('mouseleave', function () { paused = false; });
    tile.addEventListener('focusin', function () { paused = true; });
    tile.addEventListener('focusout', function () { paused = false; });

    setInterval(swap, interval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
